import { render, staticRenderFns } from "./lista_formato.vue?vue&type=template&id=1baa3320&scoped=true"
import script from "./lista_formato.vue?vue&type=script&lang=js"
export * from "./lista_formato.vue?vue&type=script&lang=js"
import style0 from "./lista_formato.vue?vue&type=style&index=0&id=1baa3320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa3320",
  null
  
)

export default component.exports